import { useContext, useRef } from "react"
import { UserContext } from "@context"
import { hasOrganiserRights } from "@helpers"
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';

const Tawk = () => {
  const tawkMessengerRef = useRef(null)
  const { user } = useContext(UserContext)
  const propertyId = process.env.REACT_APP_TAWK_PROPERTY_ID
  const widgetId = hasOrganiserRights(user) ? process.env.REACT_APP_TAWK_WIDGET_ID_ADMIN : process.env.REACT_APP_TAWK_WIDGET_ID_STAFF

  const handleTawkLoad = () => {
    if (!tawkMessengerRef.current) return

    const attributes = {};

    if (user?.me?.name) {
      attributes.name = user.me.name;
    }

    if (user?.me?.email) {
      attributes.email = user.me.email;
    }

    // Don't call setAttributes if there's nothing to set
    if (Object.keys(attributes).length === 0) return;

    tawkMessengerRef.current.setAttributes({
      name: user?.me?.name,
      email: user?.me?.email,
    }, (error) => {
      if (error) {
        console.error('Tawk setAttributes error:', error)
      }
    })
  }

  return (
    <TawkMessengerReact
      propertyId={propertyId}
      widgetId={widgetId}
      ref={tawkMessengerRef}
      onLoad={handleTawkLoad}
    />
  )
}

export default Tawk